import { createSlice } from '@reduxjs/toolkit';

const coursesData = createSlice({
  name: 'coursesData',
  initialState: {
    coursesDetails: {},
    unreadCourseNotifications: {}
  },
  reducers: {
    updateCoursesDetails: (state, action) => {
      state.coursesDetails = action.payload
    },
    handleUnreadCourseNotifications: (state, action) => { 
      state.unreadCourseNotifications = action.payload;
    }
  },
});

export const { updateCoursesDetails, handleUnreadCourseNotifications } = coursesData.actions;

export default coursesData.reducer;
